import {
  SEARCH_TRACKINGS,
  SEARCH_TRACKINGS_SUCCESS,
  SEARCH_TRACKINGS_ERROR,
  SEARCH_SAVE_KEYWORD,
  RESET_SEARCH_TRACKINGS_FLAG,
} from "./actionTypes"

const initialState = {
  keyword: "",
  oldKeyword: "",
  trackings: [],
  error: "",
  success: "",
  loading: false,
}

const trackingsSearch = (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_TRACKINGS:
      state = { ...state, loading: true }
      break
    case SEARCH_TRACKINGS_SUCCESS:
      state = {
        ...state,
        trackings: action.payload.trackings,
        error: "",
        loading: false,
        oldKeyword: state.keyword,
      }
      break
    case SEARCH_TRACKINGS_ERROR:
      state = {
        ...state,
        error: action.payload,
        success: "",
        trackings: [],
        loading: false,
      }
      break
    case SEARCH_SAVE_KEYWORD:
      state = { ...state, keyword: action.payload }
      break
    case RESET_SEARCH_TRACKINGS_FLAG:
      state = {
        ...state,
        keyword: "",
        oldKeyword: "",
        trackings: [],
        error: "",
        success: "",
        loading: false,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default trackingsSearch
